import React from 'react';
import { View, Text, StyleSheet, Button, Image, TouchableOpacity } from 'react-native';
import Amplify, {Auth, Storage } from 'aws-amplify';
import { CheckBox } from 'react-native-elements';
import EStyleSheet from 'react-native-extended-stylesheet';
import SelectFileButton from '../components/SelectFileButton';
import SignOutButton from '../components/SignOutButton';
import config from '../../src/aws-exports';
import * as ImagePicker from 'expo-image-picker';
import VerifyUploadButton from '../components/VerifyUploadButton';
import UploadFile from '../screens/UploadFile'
import mainIcon from '../assets/uploadifierSymbol.png';
import * as FileSystem from 'expo-file-system';
import { Alert } from 'react-native';


export default function SelectFile({ navigation}) {
    const [selectedImage, setSelectedImage] = React.useState(null);
    var imageSize = 0
    
    async function getFileInfoAsync() {
      try {
      let fileInfo = await FileSystem.getInfoAsync(imageURIForUpload);
          imageSize = fileInfo.size;
          console.log("image size is" , imageSize)

      return imageSize;
      }
      catch (error){
        console.log(error);
      }
    }
    
    async function uploadImageFile() {  
        console.log('verifying selected image' , selectedImage.localUri);
      }
    

    let openImagePickerAsync = async () => {
        let permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
    
        if (permissionResult.granted === false) {
          console.log("No permissions granted, popping alert to check now");
          alert("Permission to access camera roll is required!");
          return;
        }
    
        console.log("starting image picker");
        let pickerResult = await ImagePicker.launchImageLibraryAsync();
        console.log(pickerResult);

        if (pickerResult.cancelled === true) {
            return;
          }
      
          setSelectedImage({ localUri: pickerResult.uri });
         
         
        };

        

       
      
        if (selectedImage !== null) {
          
          if (imageSize > 3000000){
            if (Platform.OS === 'android' || Platform.OS === 'ios'){
              Alert.alert("File Size to large, please trim to smaller than 30 Megabytes");
              navigation.navigate('Home');
            }
            if (Platform.OS === 'web'){
              alert("File Size to large, please trim to smaller than 30 Megabytes");
              navigation.navigate('Home');
            }
          }

          return (

            
          console.log("lets try checking the image size", imageSize),
          global.imageURIForUpload = selectedImage.localUri,
            
            <View style={styles.container}>
              <Image
                source={{ uri: selectedImage.localUri }}
                style={{ width: '75%', height: '50%', resizeMode: 'contain', }}
              />
              <VerifyUploadButton 
                title="I want to upload this" 
                color="#1bb3f9" 
                onPress={() => navigation.navigate('UploadFile')} 
              />
              
              <SelectFileButton 
                title="Choose a different Image" 
                color="m#1bb3f9" 
                onPress={() => navigation.navigate('Home')} 
              />
              
              
            </View>
          ); 
      }
      
      return (
        <View style={styles.container}>
          <Image source={mainIcon} style={{ width: '75%', height: '50%', resizeMode: 'contain', }}/>
          <Text style={styles.instructions}>
            Pick an image to upload and report.
          </Text>
          <SelectFileButton 
          style={styles.button} 
          title="Choose Image" 
          onPress={openImagePickerAsync} 
          />
          
                 
        </View>
      );
    }
      
  const styles = EStyleSheet.create({
    container: {
      flex: 1,
      marginTop: 20
    },
    thumbnail: {
        width: '80%',
        height: '60%',
        resizeMode: 'contain',
    },
    instructions: {
      justifyContent: "center",
      marginTop: 50,
      marginLeft: 20,
      marginRight: 20
    }

  });